const OB= {"storedEdits":{"@media screen and (max-width:667px)":"#shopify-section-template--15937030783170__b65d0e22-9f14-4340-881b-b811d4f4e9a8>section>div>div:nth-child(1)>div>a {\n\tmargin-bottom: 50px;\n}\n\n.section-wrapper>#shopify-section-template--15937030783170__b65d0e22-9f14-4340-881b-b811d4f4e9a8 .container>.mobile-block {\n\tmargin-bottom: -25px;\n}\n\n#shopify-section-template--15937030783170__296c0ba7-3e4a-49b4-b518-54c53000ddf4 .mobile-block>.info {\n\tmargin-bottom: -25px;\n}\n\n.section .newsletter {\n\tpadding-top: 0px;\n\tpadding-left: 0px;\n\tmargin-left: 0px;\n\tbackground-color: rgba(255, 255, 255, 0);\n}\n\n#contact_form>div:nth-child(5)>input:nth-child(2) {\n\tmargin-top: 15px;\n\tpadding-left: 15px;\n}\n\n.newsletter_section #contact_form {}\n\n#contact_form {\n\tmargin-left: 0px;\n}\n\n#shopify-section-template--15937030783170__newsletter-1>div>section>div>div>div>h2>span:nth-child(3) {\n\tpadding-top: 4px;\n}\n\n#shopify-section-template--15937030783170__newsletter-1>div>section>div>div>div>h2>span:nth-child(2) {\n\tpadding-top: 3px;\n}","@media screen and (max-width:375px)":"#homepage_slider-template--15937030783170__slideshow-1>div>div>div:nth-child(5)>div:nth-child(3)>div>p>span:nth-child(2) {\n\tpadding-top: 5px;\n}\n\n.slide-2 .title-text {\n\tpadding-top: 0px;\n}\n\n#homepage_slider-template--15937030783170__slideshow-1>div>div>div:nth-child(2)>div:nth-child(3)>div>p>span:nth-child(2) {\n\tpadding-top: 7px;\n}\n\n#homepage_slider-template--15937030783170__slideshow-1>div>div>div:nth-child(3)>div:nth-child(3)>div>p>span:nth-child(2) {\n\tpadding-top: 5px;\n}\n\n#homepage_slider-template--15937030783170__slideshow-1>div>div>div:nth-child(4)>div:nth-child(3)>div>p>span:nth-child(2) {\n\tpadding-top: 5px;\n}\n\n.section-wrapper>#shopify-section-template--15937030783170__b65d0e22-9f14-4340-881b-b811d4f4e9a8 .container>.mobile-block {\n\tmargin-bottom: -35px;\n}\n\n#video-template--15937030783170__17d3becd-f5a0-45cc-bce1-2e5e0d16b65a {\n\tmargin-bottom: -65px;\n}\n\n#shopify-section-template--15937030783170__296c0ba7-3e4a-49b4-b518-54c53000ddf4 .featured-link--half .collection_title {\n\tmargin-bottom: 25px;\n}\n\n#shopify-section-template--15937030783170__b65d0e22-9f14-4340-881b-b811d4f4e9a8 .featured-link--wrap>.description {\n\tpadding-top: 0px;\n\tmargin-bottom: 20px;\n}\n\n#shopify-section-template--15937030783170__b65d0e22-9f14-4340-881b-b811d4f4e9a8>section>div>div:nth-child(2)>div>div>h2 {\n\tfont-size: 18px;\n\tmargin-bottom: 5px;\n}\n\n#shopify-section-template--15937030783170__296c0ba7-3e4a-49b4-b518-54c53000ddf4>section>div>div:nth-child(2)>div>div>h2 {\n\tfont-size: 16px;\n}\n\n#shopify-section-template--15937030783170__296c0ba7-3e4a-49b4-b518-54c53000ddf4>section>div>div:nth-child(1)>div>a {\n\tmargin-bottom: 25px;\n}\n\n.section-wrapper>#shopify-section-template--15937030783170__296c0ba7-3e4a-49b4-b518-54c53000ddf4 .container>.mobile-block {\n\tmargin-bottom: -5px;\n}","all":".one-whole .headline {\n\tletter-spacing: -1px;\n\n}\n\n.header a>.ls-is-cached {}\n\n.is-absolute .main-nav>a {\n\tpadding-right: 30px;\n}\n\n.one-whole>.position-left span {\n\ttext-shadow: 0px 5px 8px rgba(0, 0, 0, 0.5);\n}\n\n\n\n\n.blog-table .blog-table-left {}\n\n\n\n\nbody #shopify-section-template--15937030193346__main {}\n\n\n\n\nbody>.main-nav__wrapper>.main-nav>a {\n\tpadding-right: 30px;\n}"},"mqOrder":["all","@media screen and (max-width:1024px)","@media screen and (max-width:768px)","@media screen and (max-width:667px)","@media screen and (max-width:375px)"],"animatedEls":{},"storedJS":{"all":"","libs":[],"stripped":""},"videoBgs":{},"customFonts":{},"session":1681196455839}


if (typeof window.placeVidElementInner === 'undefined'){
    window.placeVidElementInner = function(selector,options,frame,showOnlyPoster){
        const {pos,url,customizations,thumbnail} = options;
        const {outer,inner} = customizations;
        const outerCustomStyle = [];
        const innerCustomStyle = [];
        let outS = {};
        let inS = {}
        for (let o in outer){
            outerCustomStyle.push(o+':'+outer[o])
            let niceO = o;
            if (o === 'background-color') niceO = 'backgroundColor'
            
            outS[niceO] = outer[o]
        }
        
        for (let o in inner){
            innerCustomStyle.push(o+':'+inner[o])
            let niceO = o;
            if (o === 'mix-blend-mode') niceO = 'mixBlendMode'
            inS[niceO] = inner[o]
        }
        const destination = frame ? frame.document : document;
        const els = destination.querySelectorAll(selector);
        const defSty = 'position:absolute;top:0;left:0;z-index:-1;height:100%;width:100%;pointer-events:none;'
        
        els.forEach(e=>{
            const outerEl = document.createElement('div')
            outerEl.setAttribute('style',defSty+outerCustomStyle.join(';'))
            outerEl.className = 'heroVideoBg'
            const vidEl = document.createElement('video');
            vidEl.src = !showOnlyPoster ? url : '';
            vidEl.autoplay = true;
            vidEl.poster = thumbnail;
            vidEl.loop = true
            vidEl.muted = true
            vidEl.playsInline = true
            vidEl.preload = 'none'
            vidEl.setAttribute('style',defSty+'object-fit:cover;object-position:'+pos+';'+innerCustomStyle.join(';'))
            outerEl.appendChild(vidEl)
            e.appendChild(outerEl)
        })
        
        return {inS,outS,thumbnail,url}
    }
}

document.addEventListener("DOMContentLoaded", ()=>{


    try{

        
        if (OB && window.location.href.indexOf('?shop')===-1){
            
            
            const {videoBgs,storedJS} = OB;
            
            for (let v in videoBgs){
                const {url,pos,customizations,thumbnail,disableOnMobile} = videoBgs[v];
                const posterOnly = disableOnMobile && window.matchMedia('(max-width: 1024px)').matches
                    
                window.placeVidElementInner(v,{url,pos,customizations,thumbnail},false,posterOnly)
            }

            const {libs,stripped} = storedJS;
            if (libs && libs.length > 0){
                libs.forEach(l=>{
                    const scr = document.createElement('script');
                    scr.setAttribute('src',l);
                    scr.classList.add('csshero-js-lib')
                    document.head.appendChild(scr);
                })
            }
            if (stripped){
                const scr = document.createElement('script');
                scr.setAttribute('id','csshero-js-code')
                scr.innerHTML = stripped
                document.head.appendChild(scr)
            }
        }
    } catch(err){
        // ERROR, NO OB?
    }
})